import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})

//  Validate service.
export class ValidateService {

    messages;
    constructor(
        private globals: GlobalService) {
        this.messages = this.globals.messages;
    }

    //  Used to validate customer profile.
    validateProfile(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.FirstName === null || item.FirstName === '') {
            validation += '<li>' + this.messages.vld_FirstName + '</li>';
            isSuccess = false;
        }
        if (item.LastName === null || item.LastName === '') {
            validation += '<li>' + this.messages.vld_LastName + '</li>';
            isSuccess = false;
        }

        if (item.Category === null || item.Category === 0) {
            validation += '<li>' + this.messages.vld_Category + '</li>';
            isSuccess = false;
        }

        if (item.Type === null || item.Type === 0) {
            validation += '<li>' + this.messages.vld_Type + '</li>';
            isSuccess = false;
        }


        if (item.Items && item.Items.length > 0) {
            let isPhoneValid = true;
            for (let i = 0; i < item.Items.length; i++) {
                if (!item.Items[i].Code || item.Items[i].Code === 0) {
                    isPhoneValid = false;
                    break;
                }
            }
            if (!isPhoneValid) {
                validation += '<li>' + this.messages.vld_item + '</li>';
                isSuccess = false;
            }
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }
    //  Used to validate Client profile.
    validateClient(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.ClientName === null || item.ClientName === '') {
            validation += '<li>' + this.messages.vld_ClientName + '</li>';
            isSuccess = false;
        }
        if (item.ClientAddress === null || item.ClientAddress === '') {
            validation += '<li>' + this.messages.vld_ClientInstitution + '</li>';
            isSuccess = false;
        }

        if (item.ClientCity === null || item.ClientCity === '') {
            validation += '<li>' + this.messages.vld_ClientCity + '</li>';
            isSuccess = false;
        }
        if (item.ClientGSM1 === null || typeof item.ClientGSM1 === 'undefined' || item.ClientGSM1 === '' || item.ClientGSM1.length < 10) {
            validation += '<li>' + this.messages.vld_ClientMobile + '</li>';
            isSuccess = false;
        }
        if (item.ClientEmail1 === null || item.ClientEmail1 === '') {
            validation += '<li>' + this.messages.vld_ClientEmail1 + '</li>';
            isSuccess = false;
        }
        if (item.ClientEmail1 !== '[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$') {
            //  validation += '<li>' + this.messages.vld_ClientEmail1 + '</li>';
            isSuccess = false;
        }
        if (item.LicenseNo === null || item.LicenseNo === '') {
            validation += '<li>' + this.messages.vld_ClientLisenceNo + '</li>';
            isSuccess = false;
        }
        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Used to validate Common component.
    validateCommon(item) {

        let validation = '<ul>';
        let isSuccess = true;
        if (item.Group_Name === null || item.Group_Name === '') {
            isSuccess = false;
        }

        if (item.Code === null || item.Code === '') {

            isSuccess = false;
        }

        if (item.Description === null || item.Description === '') {

            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }


    //  Validates item list.
    validateContact(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.title === null || item.title === '') {
            validation += '<li>Title is require field.</li>';
            isSuccess = false;
        }
        if (item.address === null || item.address === '') {
            validation += '<li>Please enter a vaild address.</li>';
            isSuccess = false;
        }

        if (item.countryId === null || item.countryId === 0) {
            validation += '<li>Please select a country.</li>';
            isSuccess = false;
        }

        if (item.stateId === null || item.stateId === 0) {
            validation += '<li>Please select a state.</li>';
            isSuccess = false;
        }

        if (item.cityId === null || item.cityId === 0) {
            validation += '<li>Please select a city.</li>';
            isSuccess = false;
        }

        if (item.zipCode === null || item.zipCode === '') {
            validation += '<li>Zip Code is require field.</li>';
            isSuccess = false;
        }

        if (item.personalEmail === null || item.personalEmail === '') {
            validation += '<li>Personal Email is require field.</li>';
            isSuccess = false;
        } else if (!this.validateEmail(item.personalEmail)) {
            validation += '<li>Please enter a valid email.</li>';
            isSuccess = false;
        }

        if (item.personalPhone === null || item.personalPhone === '') {
            validation += '<li>Personal Phone is require field</li>';
            isSuccess = false;
        } else if (!this.validatePhone(item.personalPhone)) {
            validation += '<li>Please enter a valid phone number.</li>';
            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }



    //  Used to validate Location profile.
    validateLocation(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.LocationName === null || item.LocationName === '') {
            validation += '<li>' + this.messages.vld_ClientName + '</li>';
            isSuccess = false;
        }
        if (item.ClientID === null || item.ClientID === '') {
            validation += '<li>' + this.messages.vld_ClientInstitution + '</li>';
            isSuccess = false;
        }

        if (item.LocationCity === null || item.LocationCity === '') {
            validation += '<li>' + this.messages.vld_ClientCity + '</li>';
            isSuccess = false;
        }
        if (item.LocationPhone1 === null || item.LocationPhone1 === '' || item.LocationPhone1 === '10') {
            validation += '<li>' + this.messages.vld_ClientMobile + '</li>';
            isSuccess = false;
        }
        if (item.LicenseNo === null || item.LicenseNo === '') {
            validation += '<li>' + this.messages.vld_ClientLisenceNo + '</li>';
            isSuccess = false;
        }
        validation += '</ul>';
        return isSuccess ? null : validation;
    }
    //  Used to validate Sponsor Type profile.
    validateSponsorType(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.SponsorTypeName === null || item.SponsorTypeName === '') {
            isSuccess = false;
        }
        if (item.LedgerType === null || item.LedgerType === '') {
            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Used to validate User profile.
    validateUser(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.ClientID === null || item.ClientID === '') {
            isSuccess = false;
        }
        if (item.LocationID === null || item.LocationID === '') {
            isSuccess = false;
        }
        if (item.UserName === null || item.UserName === '') {
            isSuccess = false;
        }
        if (item.UserPassword === null || item.UserPassword === '') {
            isSuccess = false;
        }
        if (item.EmployeeID === null || item.EmployeeID === '') {
            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }
    //  Used to validate Sponsor  profile.
    validateSponsor(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.SponsorCode === null || item.SponsorCode === '') {
            isSuccess = false;
        }
        if (item.SponsorName === null || item.SponsorName === '') {
            isSuccess = false;
        }
        if (item.Email === null || item.Email === '') {
            isSuccess = false;
        }
        if (item.PhoneNo === null || item.PhoneNo === '') {
            isSuccess = false;
        }
        if (item.ContactPerson === null || item.ContactPerson === '') {
            isSuccess = false;
        }
        if (item.SponsorType === null || item.SponsorType === '') {
            isSuccess = false;
        }


        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Used to validate Group profile.
    validateGroup(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.GroupCode === null || item.GroupCode === '') {
            isSuccess = false;
        }
        if (item.GroupName === null || item.GroupName === '') {
            isSuccess = false;
        }
        if (item.ApplicableFor === null || item.ApplicableFor === '') {
            isSuccess = false;
        }
        validation += '</ul>';
        return isSuccess ? null : validation;
    }
    //  Used to validate Receipt Book profile.
    validateReceiptBook(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.ReceiptBookName === null || item.ReceiptBookName === '') {
            isSuccess = false;
        }
        if (item.StartBillNo === null || item.StartBillNo === '') {
            isSuccess = false;
        }
        if (item.BillCostCentre === null || item.BillCostCentre === '') {
            isSuccess = false;
        }
        validation += '</ul>';
        return isSuccess ? null : validation;
    }
    //  Used to validate Dose Frequency profile.
    validateDoseFrequency(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.FrequencyCode === null || item.FrequencyCode === '') {
            isSuccess = false;
        }
        if (item.FrequencyDescription === null || item.FrequencyDescription === '') {
            isSuccess = false;
        }
        if (item.Quantity === null || item.Quantity === '') {
            isSuccess = false;
        }
        validation += '</ul>';
        return isSuccess ? null : validation;
    }
    //  Used to validate Tariff profile.
    validateTariff(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.ServiceID === null || item.ServiceID === '') {
            isSuccess = false;
        }
        if (item.ClassID === null || item.ClassID === '') {
            isSuccess = false;
        }
        if (item.SponsorID === null || item.SponsorID === '') {
            isSuccess = false;
        }
        if (item.SponsorTypeID === null || item.SponsorTypeID === '') {
            isSuccess = false;
        }
        if (item.Rate === null || item.Rate === '') {
            isSuccess = false;
        }
        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Used to validate LoginTemplate profile.
    validateLoginTemplate(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.LoginTemplateName === null || item.LoginTemplateName === '') {
            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Used to validate Bank.
    validateBank(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.BankName === null || item.BankName === '') {
            isSuccess = false;
        }

        if (item.ContactPerson === null || item.ContactPerson === '') {
            isSuccess = false;
        }

        if (item.CCPercent === null || item.CCPercent === '') {
            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Used to validate Class.
    validateClass(item) {
        let validation = '';
        let isSuccess = true;
        if (item.ClassName === null || item.ClassName === '') {
            validation += 'ClassName';
            isSuccess = false;
        }

        validation += '';
        return isSuccess ? null : validation;
    }

    //  Used to validate CostCentre profile.
    validateCostCentre(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.CostCentreCode === null || item.CostCentreCode === '') {
            isSuccess = false;
        }

        if (item.Name === null || item.Name === '') {
            isSuccess = false;
        }

        if (item.Address === null || item.Address === '') {
            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Validate contract details
    validateContract(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.ContractCode === null || item.ContractCode === '') {
            isSuccess = false;
        }
        if (item.ContractName === null || item.ContractName === '') {
            isSuccess = false;
        }
        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Used to validate Department.
    validateDepartment(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.ClientID === null || item.ClientID === '') {
            isSuccess = false;
        }

        if (item.LocationID === null || item.LocationID === '') {
            isSuccess = false;
        }
        if (item.DepartmentName === null || item.DepartmentName === '') {
            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Used to validate Doctor profile.
    validateDoctor(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.DoctorCode === null || item.DoctorCode === '') {
            isSuccess = false;
        }
        if (item.Prefix === null || item.Prefix === '') {
            isSuccess = false;
        }
        if (item.FirstName === null || item.FirstName === '') {
            isSuccess = false;
        }

        if (item.LastName === null || item.LastName === '') {
            isSuccess = false;
        }
        if (item.GSM1 === null || item.GSM1 === '') {
            isSuccess = false;
        }
        if (item.Specialization === null || item.Specialization === '') {
            isSuccess = false;
        }
        if (item.LicenseNo === null || item.LicenseNo === '') {
            isSuccess = false;
        }

        if (item.LocationID === 0) {
            isSuccess = false;
        }
        if (item.ClientID === 0) {
            isSuccess = false;
        }
        if (item.DoctorType === 0) {
            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Used to validate Employee profile.
    validateEmployee(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.Code === null || item.Code === '') {
            isSuccess = false;
        }
        if (item.Prefix === null || item.Prefix === '') {
            isSuccess = false;
        }

        if (item.FirstName === null || item.FirstName === '') {
            isSuccess = false;
        }

        if (item.LastName === null || item.LastName === '') {
            isSuccess = false;
        }
        if (item.Address === null || item.Address === '') {
            isSuccess = false;
        }
        if (item.DepartmentID === 0) {
            isSuccess = false;
        }
        if (item.Designation === null || item.Designation === '') {
            isSuccess = false;
        }

        if (item.GSM1 === null || item.GSM1 === '') {
            isSuccess = false;
        }

        if (item.Gender === null || item.Gender === '') {
            isSuccess = false;
        }
        if (item.Nationality === null || item.Nationality === '') {
            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    //  Used to validate Service profile.
    validateService(item) {
        let validation = '<ul>';
        let isSuccess = true;
        if (item.ServiceCode === null || item.ServiceCode === '') {
            isSuccess = false;
        }
        if (item.Name === null || item.Name === '') {
            isSuccess = false;
        }

        if (item.DeptID === 0) {
            isSuccess = false;
        }

        if (item.GroupID === 0) {
            isSuccess = false;
        }

        validation += '</ul>';
        return isSuccess ? null : validation;
    }

    validateUserTypes(item) {
        if (item.id === undefined || item.id === '' || item.type === undefined || item.type === '') {
            return false;
        } else {
            return true;
        }
    }

    validateAddress(address) {
        const re = /^[0-9a-zA-Z,][0-9a-zA-Z,\. ]*$/;
        return re.test(String(address).toLowerCase());
    }

    validateName(name) {
        const re = /^[a-zA-Z][a-zA-Z\. ]*$/;
        return re.test(String(name).toLowerCase());
    }

    // Allow number and dot and Aplhabets only
    numberAnddotonlyAndalphabetOnly(event): boolean {
        const patt = /^[0-9A-Za-z.+-\\/\\]*$/;
        const charCode = (event.which) ? event.which : event.keyCode;
        const result = patt.test(event.key) || charCode === 32;
        return result;
    }

    validateEmail(email) {
        // tslint:disable-next-line:max-line-length
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    // validateUserName(UserName) {
    //     const re = /^[a-zA-Z][a-zA-Z0-9_.]{2,19}$/;
    //     return re.test(String(UserName).toLowerCase());
    // }

    // Allow number and dot and _ and Aplhabets only
    validateUserName(event) {
        const re = /^[a-zA-Z0-9_.]$/;
        return re.test(event.key.trim());
    }

    validateLicense(license) {
        const re = /^[a-zA-Z0-9_ ]*$/;
        return re.test(String(license).toLowerCase());
    }
    validateOnlyNumberAndAlphabets(event) {
        const patt = /^([0-9a-zA-Z])$/;
        const result = patt.test(event.key);
        return result;
    }

    validateNumber(number) {
        if (number === null || number === '') {
            return false;
        }
        number = number.replace(/[-\/\\^$*+?.()|[\]{} ]/g, '');
        // tslint:disable-next-line:max-line-length
        const num = /^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]|[1-9][0-9][0-9][0-9][0-9]|[1-9][0-9][0-9][0-9][0-9][0-9]|[1-9][0-9][0-9][0-9][0-9][0-9][0-9])$/;
        return num.test(number);
    }

    validateMobile(mobile) {
        if (mobile === null || mobile === '') {
            return false;
        }
        mobile = mobile.replace(/[-\/\\^$*+?.()|[\]{} ]/g, '');
        const mobile1 = /^\d{10}$/;
        return mobile1.test(mobile);
    }

    validatePhone(phone) {
        if (phone === null || phone === '') {
            return false;
        }
        phone = phone.replace(/[-\/\\^$*+?.()|[\]{} ]/g, '');
        const phoneNum = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{5})$/;
        return phoneNum.test(phone);
    }

    validatePercent(percent) {
        const percentage = /^(0*100{1,1}\.?((?<=\.)0*)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$/;
        return percentage.test(percent);
    }

    validateAmount(amt) {
        const amount = /^\d+(?:\.\d{0,2})?$/;
        return amount.test(amt);
    }

    validatePassword(password) {
        return password && password.length >= 6;
    }

    matchPassword(password, confirmPassword) {
        return password && confirmPassword && confirmPassword === password;
    }

    // Allow to enter only Number
    numberOnly(event): boolean {
        const patt = /^([0-9])$/;
        const result = patt.test(event.key);
        return result;
    }

    // Allow number and dot only
    numberAnddotonly(event): boolean {
        const patt = /^[0-9]*\.?[0-9]*$/;
        const result = patt.test(event.key);
        return result;
    }

    // Allow number and dot and dash only
    numberAndDotAndDashonly(event): boolean {
        const patt = /^[0-9]*\.?[0-9]*\-?[0-9]*$/;
        const result = patt.test(event.key);
        return result;
    }

    // Allow number and dot only
    numberAndColononly(event): boolean {
        const patt = /^[0-9]*\:?[0-9]*$/;
        const result = patt.test(event.key);
        return result;
    }

    // Allow to enter decimal numbers
    onlyDecimalNumbers(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        const number = event.target.value.split('.');
        if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        if (number.length > 1 && charCode == 46) {
            return false;
        }
        return true;
    }

    //  Allow to enter only Aplhabets
    alphabetOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode != 32)) {
            return false;
        }
        return true;
    }
    numbersAndCommasOnly(event) {
        const patt = /^[0-9,]*$/;
        const result = patt.test(event.key);
        return result;
    }

    // Converting Text into UpperCase
    UpperCase(str) {
        str = str.toLowerCase().split(' ');
        for (let i = 0; i < str.length; i++) {
            str[i] = str[i].toUpperCase();
        }
        return str.join(' ');
    }

    // Getting Calculating Age In Years, Months & Days
    GetCalculateAge(DOB) {
        let ageYears, ageMonths, ageDays;

        if (DOB == null || DOB == undefined) {
            DOB = this.globals.CurrentDateTime;
        }
        let oldDateMoment, newDateMoment, numYears, numMonths, numDays;

        oldDateMoment = moment(new Date(DOB));
        newDateMoment = moment(new Date(this.globals.CurrentDateTime));

        numYears = newDateMoment.diff(oldDateMoment, 'years');
        oldDateMoment = oldDateMoment.add(numYears, 'years');
        numMonths = newDateMoment.diff(oldDateMoment, 'months');
        oldDateMoment = oldDateMoment.add(numMonths, 'months');
        numDays = newDateMoment.diff(oldDateMoment, 'days');

        ageYears = numYears + '';
        ageMonths = numMonths + '';
        ageDays = numDays + '';

        // // Getting And Calculating Years, Month and Days
        // const formatedDate = moment(this.globals.CurrentDateTime);
        // if (formatedDate.isValid()) {
        //     this.globals.CurrentDateTime = formatedDate;
        // }
        // const newDate = new Date(this.globals.CurrentDateTime);
        // const oldDate = new Date(DOB.toString());

        // let bthDate, curDate, days;

        // bthDate = new Date(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate());
        // curDate = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());

        // days = Math.floor((curDate - bthDate) / (1000 * 60 * 60 * 24));
        // ageYears = Math.floor(days / 365);
        // ageMonths = Math.floor((days % 365) / 30);
        // ageDays = days - (ageYears * 365) - (ageMonths * 30);

        return ageYears + '$' + ageMonths + '$' + ageDays;
    }

    // Validating Controls
    ValidateControls(validations): string {
        let text = '';
        for (let i = 0; i < validations.length; i++) {
            const data = validations[i]; // Reading Array One By One.
            const string = data['ControlName']; // Getting Control Name.
            if (document.getElementById(data['ControlID']) != undefined) {
                const element: HTMLElement = document.getElementById(data['ControlID']); // Finding Element with Id
                let temp = element['value'];
                const date = new Date(this.globals.CurrentDateTime);
                const datePipe = new DatePipe("en-US");
                const newDate = datePipe.transform(date, "dd-MM-yyyy");
                // Element type is text and it is required
                if ((element['type'] == 'text' || element['type'] == 'password') && data['IsMandatory']) {
                    // Element type is text and it is required
                    if (element['value'].trim() == '') {
                        // Value is blank
                        text = '* ' + string + ' is required';
                    } else if (data['ValidationType'] == '55') {
                        if (element['id'].includes('GSM')) {
                            // Allows Number Only.
                            if (element['value'].trim().length < this.globals.configurations['GSMLength']) {
                                // Shows error when value is less than
                                text = '* ' + string + ' ' + this.globals.configurations['GSMLength'] + ' digits only';
                            }
                        } else if (element['id'].includes('Phone')) {
                            if (element['value'].trim().length < this.globals.configurations['PhoneLength']) {
                                // Shows error when value is less than 11 character
                                text = '* ' + string + ' ' + this.globals.configurations['PhoneLength'] + ' digits only';
                            }
                        } else if (element['id'].includes('Pin')) {
                            const Pin = this.validateNumber(element['value'].trim());
                            if (element['value'].trim().length < 6) {
                                // Shows error when value is less than 11 character
                                text = '* ' + string + ' 6 digits only';
                            } else if (Pin == false) {
                                // Reomoves error when length is 11 characters
                                text = '* ' + string + ' 6 digits only';
                            } else if (Pin == true) {
                                // Reomoves error when length is 11 characters
                                text.replace('* ' + string + ' 6 digits only', '');
                            }
                        }
                    } else if (data['ValidationType'] == '56') {
                        // Allows Alphabet and Space Only.
                        const name = this.validateName(element['value'].trim());
                        if (name == false) {
                            // Shows error when value is contains other than alphabet
                            text = '* ' + string + ' contains alphabet only';
                        } else {
                            // Removes error when value is contains alphabet only
                            text.replace('* ' + string + ' contains alphabet only', '');
                        }
                    } else if (data['ValidationType'] == '57') {
                        // Allows Alphabet with number and space too.
                        const license = this.validateLicense(element['value'].trim());
                        if (license == false) {
                            // Shows error when value is contains other than alphabet and number
                            text = '* ' + string + ' contains alphabet amd number only';
                        } else {
                            // Removes error when value is contains alphabet and number.
                            text.replace('* ' + string + ' contains alphabet amd number only', '');
                        }
                    } else if (data['ValidationType'] == '58') {
                        // Allows Valid Email only.
                        const email = this.validateEmail(element['value'].trim());
                        if (email == false) {
                            // Shows error when value contains invalid Email address.
                            text = '* ' + string + ' should be valid email';
                        } else if (email == true) {
                            // Removes error when value is contains valid Email Address.
                            text.replace('* ' + string + ' should be valid email', '');
                        }
                    } else if (element.classList.contains("mat-datepicker-input")) {
                        if (newDate == element['value']) {
                            text = "* " + string + " can not be today's date!";
                        }
                    }
                } else if ((element['type'] == 'text' || element['type'] == 'password') && data['IsMandatory'] == false) {
                    // Element type is text and it is not required
                    if (data['ValidationType'] == '55') {
                        if (element['id'].includes('GSM')) {
                            // Allows Number Only.
                            if (element['value'].trim().length > 0
                                && element['value'].trim().length < this.globals.configurations['GSMLength']
                                && element['value'].trim() != '') {
                                // Shows error when value is less than 10 character
                                text = '* ' + string + ' ' + this.globals.configurations['GSMLength'] + ' digits only';
                            }
                        } else if (element['id'].includes('Phone')) {
                            if (element['value'].trim().length > 0
                                && element['value'].trim().length < this.globals.configurations['PhoneLength']
                                && element['value'].trim() != '') {
                                // Shows error when value is less than 11 character
                                text = '* ' + string + ' ' + this.globals.configurations['PhoneLength'] + ' digits only';
                            }
                        } else if (element['id'].includes('Pin')) {
                            const Pin = this.validateNumber(element['value'].trim());
                            if (element['value'].trim().length > 0 && element['value'].trim().length < 6) {
                                // Shows error when value is less than 11 character
                                text = '* ' + string + ' 6 digits only';
                            } else if (Pin == false && element['value'].trim().length > 0) {
                                // Reomoves error when length is 11 characters
                                text = '* ' + string + ' 6 digits only';
                            } else if (Pin == true || element['value'].trim().length == 0) {
                                // Reomoves error when length is 11 characters
                                text.replace('* ' + string + ' 6 digits only', '');
                            }
                        }
                    } else if (data['ValidationType'] == '56') {
                        // Allows Alphabet and Space Only.
                        const name = this.validateName(element['value'].trim());
                        if (name == false && element['value'].trim() != '' && element['value'].trim().length > 0) {
                            // Shows error when value is contains other than alphabet
                            text = '* ' + string + ' contains alphabet only';
                        } else if (name == true || element['value'].trim() == '' || element['value'].trim().length == 0) {
                            // Removes error when value is contains alphabet only
                            text.replace('* ' + string + ' contains alphabet only', '');
                        }
                    } else if (data['ValidationType'] == '57') {
                        // Allows Alphabet with number and space too.
                        const license = this.validateLicense(element['value'].trim());
                        if (element['value'].trim().length > 0 && license == false && element['value'].trim() != '') {
                            // Shows error when value is contains other than alphabet and number
                            text = '* ' + string + ' contains alphabet amd number only';
                        } else if (license == true || element['value'].trim() == '' || element['value'].trim().length == 0) {
                            // Removes error when value is contains alphabet and number.
                            text.replace('* ' + string + ' contains alphabet amd number only', '');
                        }
                    } else if (data['ValidationType'] == '58') {
                        // Allows Valid Email only.
                        const email = this.validateEmail(element['value'].trim());
                        if (element['value'].trim().length > 0 && email == false && element['value'].trim() != '') {
                            // Shows error when value contains invalid Email address.
                            text = '* ' + string + ' should be valid email';
                        } else if (email == true || element['value'].trim() == '' || element['value'].trim().length == 0) {
                            // Removes error when value is contains valid Email Address.
                            text.replace('* ' + string + ' should be valid email', '');
                        }
                    } else if (element['value'].trim() != '' && element['value'].trim().length > 0) {
                        // There is Value in textbox
                        text.replace('* ' + string + ' is required ', '');
                    }
                } else if (element['type'] == 'select-one' && data['IsMandatory']) {
                    // Element type is select and it is required
                    if (element['value'].trim() == '') {
                        text = '* ' + string + ' is required';
                    } else if (element['value'].trim() != '') {
                        text.replace('* ' + string + ' is required', '');
                    }
                }
            }

        }
        return text;
    }
}
